import { useMutation } from '@tanstack/react-query';
import { CompanyTradeDataService, TradeDataService } from 'src/services/api';

export const useMutateExportBOLsList = () => {
  const { isPending, mutateAsync } = useMutation({
    mutationFn: (query: string) => TradeDataService.exportListBOLs(query),
  });
  return {
    isPending,
    mutateAsync,
  };
};
export const useMutateExportDataTableTradeData = () => {
  const { isPending, mutateAsync } = useMutation({
    mutationFn: (props: { url: string, params: Record<string, any> }) => TradeDataService.exportDataTableTradeData(props.url, props.params),
  });
  return {
    isPending,
    mutateAsync,
  };
};


export const useMutateExportBOLsListByCompany = () => {
  const { isPending, mutateAsync } = useMutation({
    mutationFn: (query: string) => {
      return CompanyTradeDataService.exportListBOLs(query)
    },
  });
  return {
    isPending,
    mutateAsync,
  };
};
